"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
const wp_query_params = {
  per_page: 4,
  orderby: "date",
  order: "desc"
};
const wp_query = new WP_Query(wp_query_params);
function ProductsGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-[420px] rounded-none bg-secondary/30 animate-pulse" />)}
      </div>;
  }
  if (error || products.length === 0) {
    return <div className="text-center py-12">
        <p className="font-default text-lg text-muted-foreground">
          No research compounds available at this time. Please contact our laboratory.
        </p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => <Card key={product.id} data-index={i} className="group relative overflow-hidden rounded-none border-border/20 bg-card transition-all duration-500 hover:shadow-2xl hover:border-primary/40 flex flex-col">
          {}
          <div className="relative aspect-[4/5] overflow-hidden bg-black p-6 flex items-center justify-center">
            {}
            {i < 2 && <Badge className="absolute top-4 left-4 z-10 bg-primary text-primary-foreground border-none px-3 py-1 text-[10px] font-bold tracking-widest uppercase shadow-sm rounded-none">
                Certified Pure
              </Badge>}

            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-contain transition-transform duration-700 ease-out group-hover:scale-110" loading="lazy" /> : <div className="h-full w-full bg-secondary/40 rounded-none flex items-center justify-center">
                <span className="text-muted-foreground text-xs font-mono uppercase tracking-widest">No Visual Data</span>
              </div>}

            {}
            <div className="absolute inset-x-4 bottom-4 translate-y-[120%] opacity-0 transition-all duration-400 ease-out group-hover:translate-y-0 group-hover:opacity-100 z-20">
              <AddToCartButton productId={product.id} className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg py-6 text-xs font-bold tracking-widest uppercase rounded-none" text="Acquire Compound" showQuantity={false} />
            </div>
            
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-0 transition-opacity duration-400 group-hover:opacity-100 pointer-events-none" />
          </div>

          {}
          <CardContent className="p-6 flex flex-col flex-grow">
            <Link to={product.link} className="block group-hover:text-primary transition-colors duration-300 mb-2">
              <h3 className="font-default text-xl font-bold text-foreground line-clamp-2 leading-tight tracking-tight uppercase">
                {product.title}
              </h3>
            </Link>

            <div className="font-mono text-[11px] text-primary mb-4 tracking-widest uppercase">
              Purity Index: &gt;99.8%
            </div>

            {product.short_description && <div className="font-default text-sm text-muted-foreground line-clamp-2 mb-4 [&>p]:mb-0 flex-grow leading-relaxed" dangerouslySetInnerHTML={{
          __html: product.short_description
        }} />}

            <div className="flex items-center justify-between mt-auto pt-4 border-t border-border/10">
              <span className="font-mono text-lg font-medium text-foreground opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                ${product.price?.toFixed(2) || "0.00"}
              </span>
              <Link to={product.link} className="text-primary text-xs font-bold tracking-widest uppercase flex items-center gap-2 hover:translate-x-1 transition-transform">
                View Details →
              </Link>
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
export default function LeNostreRicettePiuAmate() {
  return <section data-section-id="223847" id="featured-compounds" className="py-24 bg-background text-foreground relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-default text-4xl md:text-6xl font-bold text-foreground mb-6 tracking-tighter uppercase">
            Featured Compounds
          </h2>
          <p className="font-default text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            Explore our elite selection of high-purity research peptides. Each batch is rigorously 
            tested to ensure the Aurelian Standard of scientific excellence and laboratory precision.
          </p>
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 4,
        orderby: "date",
        order: "desc"
      }}>
          <ProductsGridConsumer />
        </EcommerceProductsProvider>

        <div className="mt-16 text-center">
          <Link to="/ShopPage">
            <Button variant="outline" size="lg" className="font-default rounded-none px-10 py-7 text-xs font-bold tracking-widest uppercase border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-500">
              View Full Catalog
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}